export default __webpack_public_path__ + "static/media/coffe.0358fedc.png";